import { render, staticRenderFns } from "./onlyForm.vue?vue&type=template&id=30713aac&scoped=true"
import script from "./onlyForm.vue?vue&type=script&lang=js"
export * from "./onlyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30713aac",
  null
  
)

export default component.exports